import type { ModalFieldErrors } from './modalFormValidation';

export const INTEGRATION_URL_ID = 'connector-integration-url';
export const INTEGRATION_ERROR_BANNER_ID = 'connector-integration-error-banner';

export const TRAINING_JOB_MODEL_NAME_ID = 'training-job-model-name';
export const TRAINING_JOB_DATASETS_ID = 'training-job-datasets';
export const TRAINING_JOB_AGENTS_ID = 'training-job-agents';
export const TRAINING_JOB_PREVIEW_ID = 'training-job-preview';
export const TRAINING_JOB_ERROR_BANNER_ID = 'training-job-error-banner';

export function validateIntegrationForm(url: string): ModalFieldErrors {
  const errors: ModalFieldErrors = {};
  if (!url.trim()) {
    errors[INTEGRATION_URL_ID] = 'URL is required';
  }
  return errors;
}

export function validateTrainingJobForm(params: {
  model_name: string;
  modelNameMaxLen: number;
  dataset_ids: string[];
  hasEligibleAgents: boolean;
  previewConfirmed?: boolean;
  missingBaseModelAgents?: string[];
}): ModalFieldErrors {
  const errors: ModalFieldErrors = {};

  if (!params.model_name.trim()) {
    errors[TRAINING_JOB_MODEL_NAME_ID] = 'Model name is required';
  } else if (params.model_name.length > params.modelNameMaxLen) {
    errors[TRAINING_JOB_MODEL_NAME_ID] =
      `Model name must be at most ${params.modelNameMaxLen} characters`;
  }

  if (params.dataset_ids.length === 0) {
    errors[TRAINING_JOB_DATASETS_ID] = 'Select at least one saved dataset from the registry';
  }

  if (!params.hasEligibleAgents) {
    errors[TRAINING_JOB_AGENTS_ID] =
      'Select at least one trainable agent with a base model from the dataset preview.';
  }

  if (params.missingBaseModelAgents && params.missingBaseModelAgents.length > 0) {
    errors[TRAINING_JOB_AGENTS_ID] = `Choose a base model for: ${params.missingBaseModelAgents.join(', ')}`;
  }

  if (params.previewConfirmed === false) {
    errors[TRAINING_JOB_PREVIEW_ID] = 'Run Preview before starting the training job.';
  }

  return errors;
}
